<mat-card class="cardWithShadow overflow-hidden">
  <div
    class="bg-{{ courseDetail()?.courseType }} text-white p-y-10 p-x-24"
  >
    <mat-card-title class="d-flex align-items-center gap-10">
      <a
        (click)="goBack()"
        mat-icon-button
        class="text-white d-flex justify-content-center"
      >
        <i-tabler name="chevron-left" class="icon-18 d-flex"></i-tabler>
      </a>
      {{ courseDetail()?.courseName }}
    </mat-card-title>
  </div>
</mat-card>

<mat-card class="cardWithShadow">
  <mat-card-content>
    <mat-vertical-stepper #stepper>
      <mat-step>
        <ng-template matStepLabel>Introduction</ng-template>
        <h3 class="m-t-12">Step 1 - Introduction</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Get the sample code</ng-template>
        <h3 class="m-t-12">Step 2 - Get the sample code</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>
          Create a Firebase project and Set up your app</ng-template
        >
        <h3 class="m-t-12">Step 3 - Create a Firebase project and Set up your app</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel
          >Install the Firebase Command Line Interface</ng-template
        >
        <h3 class="m-t-12">Step 4 - Install the Firebase Command Line Interface</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Deploy and run the web app</ng-template>
        <h3 class="m-t-12">Step 5 - Deploy and run the web app</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>The Functions Directory</ng-template>
        <h3 class="m-t-12">Step 6 - The Functions Directory</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel
          >Import the Cloud Functions and Firebase Admin modules</ng-template
        >
        <h3 class="m-t-12">Step 7 -Import the Cloud Functions and Firebase Admin modules</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Welcome New Users</ng-template>
        <h3 class="m-t-12">Step 8 - Welcome New Users</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Images moderation</ng-template>
        <h3 class="m-t-12">Step 9 - Images moderation</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>New Message Notifications</ng-template>
        <h3 class="m-t-12">Step 10 - New Message Notifications</h3>
        <p>
          This is an example step of the course. You can put anything in here
          from example codes to videos.
        </p>
        <p>
          To install the CLI you need to have installed npm which typically
          comes with NodeJS.To install or upgrade the CLI run the following npm
          command:
        </p>
        <p>npm -g install &#64;angular/cli</p>
        <p>
          To verify that the CLI has been installed correctly, open a console
          and run:
        </p>
        <p>ng version</p>
        <h3>Install dependencies</h3>
        <p>To moderate the images we'll need a few Node.js packages:</p>
        The Google Cloud Vision Client Library for Node.js:
        &#64;google-cloud/vision to run the image through the Cloud Vision API
        to detect inappropriate images. The Google Cloud Storage Client Library
        for Node.js: &#64;google-cloud/storage to download and upload the images
        from Cloud Storage. A Node.js library allowing us to run processes:
        child-process-promise to run ImageMagick since the ImageMagick
        command-line tool comes pre-installed on all Functions instances.
        <p>
          To install these three packages into your Cloud Functions app, run the
          following npm install --save command. Make sure that you do this from
          the functions directory.
        </p>
        <p>
          npm install --save &#64;google-cloud/vision &#64;google-cloud/storage
          child-process-promise
        </p>
        <p>
          This will install the three packages locally and add them as declared
          dependencies in your package.js file.
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Congratulations!</ng-template>
        <h3 class="m-t-12">Step 11 - Congratulations!</h3>
        <p>
          You've built a full-fidelity, offline-capable progressive web app by
          leveraging the power of reusable Web Components and Firebase. Why
          bother with a native app when you know how to do all that?!
        </p>
        <div class="d-flex align-items-center gap-12">
          <button mat-flat-button matStepperPrevious class="bg-secondary">Back</button>
          <button mat-flat-button (click)="stepper.reset()">Reset</button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </mat-card-content>
</mat-card>
